module.exports = __webpack_public_path__ + "static/media/banner-site.d950049b.png";